import { gql } from '__generated__';

export default gql(`
  mutation RevokeTicketNumbers($input: RevokeTicketNumbersInput!) {
    revokeTicketNumbers(input: $input) {
      id
      assigned_ticket_number_count
      missing_ticket_number_count
      ticket_numbers_published
      ticket_number_sequences {
        id
        assigned_ticket_number_count
        locked_ticket_number_count
      }
    }
  }
`);
